$(".sl-menu-new-content-left-item").mouseenter(function () {
  $(this).parent("a").siblings().find(".sl-menu-new-content-left-item").css({
    color: "#ccc",
    padding: "20px 0px 20px 32px",
    background: "#171717",
  });
  $(this).css({
    color: "#fff",
    padding: "20px 0px 20px 40px",
    background: "#383838",
    "border-radius": "12px",
  });
});
$(".sl-menu-new-content-left-box .sl-menu-new-content-left-box-a").mouseenter(
  function () {
    var i = $(this).index();
    var target = $(this)
      .parents(".sl-menu-new-content-left-box")
      .siblings(".sl-menu-new-content-right-box")
      .find(".sl-menu-new-content-product-box")
      .eq(i);
    if (i === 0 && target.is(":visible")) {
      return;
    }
    target.siblings().hide().end().stop().fadeIn();
  }
);
$(".sl-menu-new-all-box .sl-menu-new-title-content-box").mouseenter(
  function () {
    $(".transparent-on-top header").addClass("sl-header-mouseenter-bcg")
    $(this)
      .find(".sl-v2-header-bottom-line")
      .addClass("sl-menu-new-title-active");
    $(this)
      .siblings()
      .find(".sl-menu-new-title")
      .removeClass("sl-menu-new-title-active");
    $(this)
      .find(".sl-v2-header-bottom-line")
      .removeClass("sl-menu-new-title-inactive");
    $(this).find(".sl-menu-new-content").stop().fadeIn(200);
    $(this).siblings().find(".sl-menu-new-content").stop().fadeOut(200);
  }
);
$(".sl-menu-new-title-bgc-box").mouseenter(function () {
  $(".sl-menu-new-title-bgc").fadeIn(200);
});
$(".sl-menu-new-title-bgc-box").mouseleave(function () {
  $(".sl-menu-new-title-bgc").fadeOut(200);
});
$(".sl-menu-new-all-box .sl-menu-new-title-content-box").mouseleave(
  function () {
     $(".transparent-on-top header").removeClass("sl-header-mouseenter-bcg")
    $(this)
      .find(".sl-v2-header-bottom-line")
      .removeClass("sl-menu-new-title-active");
    $(this)
      .find(".sl-v2-header-bottom-line")
      .addClass("sl-menu-new-title-inactive");
    $(this).find(".sl-menu-new-content").css("display", "none");
    $(this).find("a").find(".sl-menu-new-content-left-item").css({
      color: "#ccc",
      padding: "20px 0px 20px 32px",
      background: "#171717",
    });
    $(
      ".sl-menu-new-content-left-box .sl-menu-new-content-left-box-a-first"
    ).css({
      color: "#fff",
      padding: "20px 0px 20px 40px",
      background: "#383838",
      "border-radius": "12px",
    });
    $(this).find(".sl-menu-new-content-product-box").css("display", "none");
    $(
      ".sl-sl-menu-new-content-product-box-all .sl-menu-new-content-product-box-first"
    ).css("display", "flex");
  }
);
